import { createTheme, Theme, adaptV4Theme } from '@mui/material/styles';
import { defaultTheme } from './index';
import defaultDark from './darkTheme';

declare module '@mui/styles' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export const isLightTheme = (): boolean => {
  const theme = window.localStorage.getItem('arborTheme');
  return theme === 'light' || theme === null;
};

const currentTheme = isLightTheme() ? defaultTheme : defaultDark;

if (!isLightTheme()) {
  // override body background color
  document.body.style.backgroundColor = currentTheme.palette.primary.background;
  // ovewrite color from index.scss
  document.body.style.color = currentTheme.palette.primary.formItem;
}
// @ts-ignore
export default createTheme(adaptV4Theme(currentTheme));
